import { createRoot } from 'react-dom/client';
import Main from '@components/Main';
import IntranetThemeProvider from '@hendersonengineers/ui/components/IntranetThemeProvider';

const App = () => <IntranetThemeProvider><Main /></IntranetThemeProvider>;

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
